<template>
    <Notifications />
</template>

<script>
import Notifications from "@/components/templates/Notifications";

export default {
  components: { Notifications },
};
</script>
